import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Route } from '@angular/router';
import { forTRANSLATIONS_EN, ReTRANSLATIONS_EN } from 'src/app/i18n/translations.en';
import { forTRANSLATIONS_HI, ReTRANSLATIONS_HI } from 'src/app/i18n/translations.hi';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CaptchaService } from 'src/app/services/captcha.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  forgotForm: FormGroup;
  isSubmit: Boolean = false;
  OTP: Number = 0;
  submitOTP: Number = 0;
  isOTPverify: boolean = false;
  isOTPVerified: Boolean = false;
  currentYear: any;
  constructor(private fb: FormBuilder, private toastService: ToastService, private authService: AuthService, private captchaService: CaptchaService, private route: ActivatedRoute) {
    // Initialize the form group
    this.forgotForm = this.fb.group({
      // sMobile: ['', [Validators.required,Validators.pattern('^[0-9]{10}$'),Validators.minLength(10), Validators.maxLength(10)]],
      UserId: ['', Validators.required],
      sPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern('^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).+$')]],
      confirmPassword: ['', [Validators.required]]
    },
      {
        validators: this.passwordMatchValidator(),  // Apply custom validator to the whole form
      }
    );
  }
  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();

  }
  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('sPassword');
      const confirmPassword = control.get('confirmPassword');

      return password && confirmPassword && password.value !== confirmPassword.value
        ? { passwordsMismatch: true }
        : null;
    };
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  SentOTP() {


    var userID = this.forgotForm.get('UserId')?.value;

    // if(userID==null || userID==undefined || userID==''){
    //   this.toastService.showError("Please enter mobile number");
    //   return;
    // }
    // if(userID.length<10){
    //   this.toastService.showError("Please enter valid mobile number");
    //   return;
    // }
    this.authService.varifyUserMobile(userID).subscribe({
      next: (response) => {

        if (response.status === 200) {
          this.isOTPVerified = true;
          // this.OTP = Math.floor(100000 + Math.random() * 900000);
          this.OTP = response.data.otp;

        }
        else {
          this.toastService.showError(response.message);
        }

      },
      error: (err) => {
        console.error('Login failed', err);
        //this.errorMessage = 'Login failed. Please try again.';
      }
    });
  }
  verifyOTP() {

    var otp = this.submitOTP;
    if (otp == null || otp == undefined) {
      this.toastService.showError("Please enter OTP");
      return;
    }
    if (Number(this.OTP) != Number(this.submitOTP)) {
      this.toastService.showError("Please enter valid OTP");
      return;
    }
    this.isOTPverify = true;
  }
  StoreOTP(event: any) {

    this.submitOTP = Number(event.target.value ? event.target.value : 0);
  }
  SubmitData() {

    if (this.forgotForm.invalid) {
      return;
    }
    else {
      this.authService.ChangePassword(this.forgotForm.value).subscribe({
        next: (response) => {
          if (response.status === 200) {
            this.toastService.showSuccess(response.message);
            setTimeout(() => {
              this.forgotForm.reset();
              this.isSubmit = false;
              this.isOTPverify = false;
              this.isOTPVerified = false;
              this.OTP = 0;
              this.submitOTP = 0;
            }, 2000);
          }
          else {
            this.toastService.showError(response.message);
          }
        },
        error: (error) => {
          this.toastService.showError(error.message);
        },
      });
    }
  }
  // Theme & Language
  isDark = false;
  isEnglish = true;

  // Captcha
  captchaCode = '';

  // Translations
  translations = forTRANSLATIONS_EN;



  // Theme Toggle
  toggleTheme(): void {
    this.isDark = !this.isDark;
    document.documentElement.classList.toggle('dark', this.isDark);

  }

  // Language Toggle
  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish; // Toggle the language flag

    // Update translations based on the current language
    this.translations = this.isEnglish ? forTRANSLATIONS_EN : forTRANSLATIONS_HI;
  }
}
